export { VerifiedIcon } from "./VerifiedIcon";
